import { Inject, Injectable } from "@angular/core";
import { EditionsService } from "@carnegie-learning/data-access-cure";
import { EDITIONS_SERVICE } from "@carnegie-learning/data-access-angular-cure";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import * as activeEditionsActions from "../actions/active-editions.action";

@Injectable()
export class ActiveEditionsEffects {
    constructor(
        private actions$: Actions,
        @Inject(EDITIONS_SERVICE) private editionsService: EditionsService,
    ) {}

    loadActiveEditions$ = createEffect(() =>
        this.actions$
            .pipe(ofType(activeEditionsActions.LoadActiveEditions))
            .pipe(
                switchMap(action => {
                    return this.editionsService.getActiveEditions().pipe(
                        map(editions => editions),
                        map(editions =>
                            activeEditionsActions.LoadActiveEditionsSuccess({
                                payload: editions
                            })
                        ),
                        catchError(error =>
                            of(
                                activeEditionsActions.LoadActiveEditionsFail({
                                    payload: error
                                })
                            )
                        )
                    );
                })
            )
    );
}
